import { PAUSE_NEWS_TICKER, RESUME_NEWS_TICKER } from './types'

export const pauseNewsTicker = () => ({
  type: PAUSE_NEWS_TICKER
})

export const resumeNewsTicker = () => ({
  type: RESUME_NEWS_TICKER
})
